import "../sparkle_namespace.js";

if (!window.Sparkle.Client) {
  window.Sparkle.Client = {};
}
